import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { softseeUninstallPageQuery, softseeUninstallTableQuery } from '../api/devices'
import { toast } from '../ui/notify'
import { Spinner } from '../ui/Spinner'
import { postKitForm } from './softseeKitForm'
import { SoftseeHtmlTable } from './SoftseeHtmlTable'
import type { ScreenProps } from './screens'

/**
 * Fila Uninstall Applications - uninstallableApplications.php si
 * UninstallApplicationsModel. Uninstall / Cancel scriu UNS.
 */

const HEADS = ['Name', 'Version', 'Platform', 'Action']

export function DeviceSoftseeUninstall({ id }: ScreenProps) {
  const query = useQueryClient()
  const page = useQuery(softseeUninstallPageQuery(id))
  const [search, setSearch] = useState('')
  const [start, setStart] = useState(0)
  const [length, setLength] = useState(10)

  const table = useQuery({
    ...softseeUninstallTableQuery(id, { start, length, search }),
    placeholderData: keepPreviousData,
    enabled: !!page.data,
  })

  if (page.error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {page.error.message}
      </div>
    )
  }
  if (!page.data) return <Spinner />

  return (
    <div className="device-softsee-uninstall">
      <div className="row">
        <div className="col-md-12">
          <SoftseeHtmlTable
            id="deviceSoftseeUninstall"
            tableClass="uninstall-table"
            heads={HEADS}
            rows={table.data?.data ?? []}
            total={table.data?.recordsFiltered ?? 0}
            fetching={table.isFetching}
            error={table.isError ? (table.error as Error).message : null}
            search={search}
            start={start}
            length={length}
            onSearch={(q) => {
              setSearch(q)
              setStart(0)
            }}
            onStart={setStart}
            onLength={(n) => {
              setLength(n)
              setStart(0)
            }}
            onFormSubmit={async (form) => {
              /* Cancel uninstall vine stins: capatul ar trimite inca o comanda UNS. */
              if (!form.classList.contains('uninstallApplicationForm')) return
              if (!confirm('Are you sure?')) return
              try {
                const message = await postKitForm(form, id, 'softsee')
                toast(message, 'Success', 'success')
                await query.invalidateQueries({ queryKey: ['device', id, 'softsee-uninstall'] })
              } catch {
                toast('Something went wrong.', 'Error', 'error')
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}
